import { Pipe } from '@angular/core';
import { isString } from '../utils/utils';
var DecodeURIPipe = (function () {
    function DecodeURIPipe() {
    }
    DecodeURIPipe.prototype.transform = function (input) {
        if (!isString(input)) {
            return input;
        }
        return decodeURI(input);
    };
    return DecodeURIPipe;
}());
export { DecodeURIPipe };
DecodeURIPipe.decorators = [
    { type: Pipe, args: [{
                name: 'decodeURI'
            },] },
];
/** @nocollapse */
DecodeURIPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=decode-uri.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/string/decode-uri.pipe.js
// module id = 275
// module chunks = 103